import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Network } from '@capacitor/network';
import { isNativeApp } from '../utils/platform';

// Native-only: shows a persistent banner while the device has no connection,
// and a brief "back online" confirmation when it returns. Handles connection
// drops that happen *after* the app has loaded (the bundled error.html handles
// the no-connection-at-launch case).
const OfflineBanner = () => {
  const [offline, setOffline] = useState(false);
  const [restored, setRestored] = useState(false);

  useEffect(() => {
    if (!isNativeApp()) return undefined;
    let sub;

    const apply = (connected) => {
      setOffline((wasOffline) => {
        if (!connected) return true;
        if (wasOffline) setRestored(true); // was offline, now back
        return false;
      });
    };

    Network.getStatus().then((s) => apply(s.connected));
    Network.addListener('networkStatusChange', (s) => apply(s.connected)).then((h) => {
      sub = h;
    });

    return () => {
      if (sub) sub.remove();
    };
  }, []);

  return (
    <>
      <Snackbar
        open={offline}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="warning" icon={<WifiOffIcon fontSize="inherit" />} sx={{ width: '100%' }}>
          No internet connection
        </Alert>
      </Snackbar>
      <Snackbar
        open={restored}
        autoHideDuration={2500}
        onClose={() => setRestored(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          Back online
        </Alert>
      </Snackbar>
    </>
  );
};

export default OfflineBanner;
